module.exports = __webpack_public_path__ + "img/iSTAY.0beef15b.png";